import { createContext } from 'react';

/**
 * Value provided by the EditListing context — the edit-page exit/publish
 * actions.
 */
export interface EditListingContextType {
  exit: (hasErrors: boolean, isFromLiveListing: boolean) => void;
  publish: () => void;
}

/**
 * Context for the edit-page actions.
 *
 * The provider (`EditListingProvider`) lives in `EditListingContext.tsx`; the
 * context object is split out here so it can be consumed — e.g. by the test
 * mock provider — without pulling in the provider's heavy dependency graph
 * (the v1 RESO media dialog, the publish/exit hooks).
 */
export const EditListingContext = createContext<
  EditListingContextType | undefined
>(undefined);
